import { Component, ElementRef, ViewChild } from '@angular/core';
import { Voice } from '../../models/voice';
import { VoiceService } from '../../services/voice.service';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { NgFor, NgIf } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { VoiceProvider } from '../../models/enums/voice-provider';

@Component({
  selector: 'app-voice-selection-dialog',
  standalone: true,
  imports: [
    MatDividerModule,
    MatDialogModule,
    MatButtonModule,
    MatTableModule,
    MatFormFieldModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    ReactiveFormsModule,
    NgFor,
    MatProgressSpinnerModule,
    NgIf
  ],
  templateUrl: './voice-selection-dialog.component.html',
  styleUrl: './voice-selection-dialog.component.scss'
})
export class VoiceSelectionDialogComponent {
  voices: Voice[] = [];
  displayedColumns: string[] = ['Name', 'Accent', 'Gender', 'Provider', 'Play', "Action"];
  providers: string[] = ['ALL'];
  genders: string[] = ['ALL'];
  accents: string[] = ['ALL'];
  dataSource!: MatTableDataSource<Voice>;
  genderChangeValue: FormControl = new FormControl('ALL');
  accentChangeValue: FormControl = new FormControl('ALL');
  providersChangeValue: FormControl = new FormControl('ALL');
  isVoicePlaying: boolean = false;
  wasButtonClicked: boolean = false;
  isLoading: boolean = false;
  playingVoiceId: string = '';
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('audio2') audioPlayerRef!: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<VoiceSelectionDialogComponent>, 
    private voiceService: VoiceService
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit() {
    this.fetchVoices();
    this.subscribeToGenderSelectValueChange();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.addEventListenerToAudio();
  }

  fetchVoices() {
    this.isLoading = true;

    this.voiceService.fetchVoices().subscribe(voices => {
      this.voices = voices;
      this.dataSource.data = this.voices;
      this.providers = [... this.providers, ... new Set(this.voices.flatMap(voice => voice.voiceProvider.toString()))];
      this.accents = [... this.accents, ... new Set(this.voices.flatMap(voice => voice.accent))];
      this.genders = [... this.genders, ... new Set(this.voices.flatMap(voice => voice.gender))];
      this.isLoading = false;
    });
  }

  playVoice(voice: Voice) {
    if (this.isVoicePlaying) {
      this.isVoicePlaying = false;
      this.audioPlayerRef.nativeElement.pause();
      this.playingVoiceId = '';
    } else {
      this.audioPlayerRef.nativeElement.src = voice.sample;
      this.audioPlayerRef.nativeElement.load();
      this.audioPlayerRef.nativeElement.play();
      this.isVoicePlaying = true;
      this.wasButtonClicked = true;
      this.playingVoiceId = voice.id;
    }
  }

  pauseAudio() {
    this.audioPlayerRef.nativeElement.pause();
  }

  addEventListenerToAudio() {
    this.audioPlayerRef.nativeElement.addEventListener('ended', () => {
      this.isVoicePlaying = false;
    });
  }

  onSelectClicked(voice: Voice) {
    this.dialogRef.close(voice);
  }

  // Filtering
  applyFilter() {
    this.dataSource.data = this.voices.filter(voice => {
      return voice.gender.includes(this.genderChangeValue.value == 'ALL' ? '' : this.genderChangeValue.value)
        && voice.accent.includes(this.accentChangeValue.value == 'ALL' ? '' : this.accentChangeValue.value)
        && (voice.voiceProvider.toString() == this.providersChangeValue.value || this.providersChangeValue.value == 'ALL');
    });
  }

  private subscribeToGenderSelectValueChange() {
    this.genderChangeValue.valueChanges.subscribe(value => {
      if (value == 'ALL') {
        this.accents = ['ALL', ...new Set(this.voices.map(voice => voice.accent))];
      }
      else
        this.accents = ['ALL', ...new Set(this.voices.filter(voice => voice.gender == value).map(voice => voice.accent))];
    });
  }
}
